export default __webpack_public_path__ + "static/media/android.1f035cbc.png";